import {useEffect} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'

const API_URL = process.env.REACT_APP_API_URL


const Resumensolicitud = ( props:any ) => {
  /*********************************Constantes**************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{

      const body= 
      {data:{
        paso1:props?.info,
        paso2:props?.infostepdos
      }
    }
      
          await axios.post(API_URL+'/v1/newctx', body)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Request has created',
            showConfirmButton: false,
            timer: 1500
          })
          //window.location.reload();
        });
        
    }
  
    catch(error:any){
      console.log(error)

    }

    
   }

/************************************************************************************ */

    // Obtén una referencia a la tabla como un elemento HTMLTableElement
    const arrayDeObjetos = Object.entries(props?.infostepdos.llistVpnOutbund).map(([nombre, valor]) => {
      return { nombre, valor };
    });
    const arrayDeObjetosIntra = Object.entries(props?.infostepdos.listIntraOutbund).map(([nombre, valor]) => {
      return { nombre, valor };
    });

    const arrayDeObjetosInter = Object.entries(props?.infostepdos.listInterOutbund).map(([nombre, valor]) => {
      return { nombre, valor };
    });
    
    const arrayDeObjetosEdge = Object.entries(props?.infostepdos.listEdgeOutbund).map(([nombre, valor]) => {
      return { nombre, valor };
    });
    

  return (
    
    <>
    {props?.infostepdos && props?.info && props?.id ===null && 
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props?.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                {/* begin::Heading */}
                <Card4
                  icon='/media/svg/files/NubeTD.svg'
                  title=' '
                  description=''></Card4>
                  <div className='text-center mb-5'>
                  <h1 className='text-dark fw-bolder mb-3'>CTX Request</h1>
                  <div className='fw-semibold fs-6'>Please verify that all information is correct before submitting your application.</div>
                  </div>
                {/* begin::Heading */}
              <div className="card-body card-scroll h-350px">
                  <div className='bg-light-info p-8 rounded text-center'>
                    <div >
                      <p> <strong className='text-info'> Cloud:</strong>  {props?.info.cloud}</p>
                      <p> <strong className='text-info'> Location type:</strong> {props?.info.tipo_locacion}</p>
                      <p> <strong className='text-info'> Continent:</strong> {props?.info.continente}</p>
                      <p> <strong className='text-info'> Region:</strong> {props?.info.region}</p>
                      <p> <strong className='text-info'> CTX Type:</strong> {props?.info.type_ctx}</p>
                      <p> <strong className='text-info'> Plan: </strong> {props?.info.Throughput}</p>

                    </div>
                  </div>
                  <br />
    
                 {/* begin::Table 1 */}
                 {props?.info.listVPNcon.length !== 0 &&
                  <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VPN Connectors</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_0'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                      <th>Quantity</th>
                                      <th>Connector Size </th>                               
                                      <th>Total</th>
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center' id='zx'>
                                      {props?.info.listVPNcon.map((d:any,i:any)=>(
                                          <tr key={i}>
                                         
                                            <td>{d.Cantidad}</td>
                                            <td>{d.Connectcap}</td>
                                            <td>{d.total}</td>
                                         
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}
                              </table>
                              {/* end::Table */}
                          </div>
                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>              
                </div>}
                {/* end::Table 1 */}
                {/* begin::Table 2 */}
              { props?.info.listCloudConnIntra.length !== 0 &&
              <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Intra Region</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                          <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                             
                                      <th>Conection Type</th> 
                                      <th>Region</th>
                                      <th>Availability Zones</th>
                                      <th>Connector Size </th>                      
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {props?.info.listCloudConnIntra.map((d:any,i:any)=>(
                                          <tr key={i}>
                                          <td>{d.ConexionIntra}</td>
                                          <td>{d.RegionIntra}</td>
                                          <td>{d.availability}</td>
                                          <td>{d.CapacidadIntra}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 2*/}

              {/* begin::Table 2B*/}
              { props?.info.listCloudConnInter.length !== 0 &&
              <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Inter Region</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                          <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                             
                                      <th>Conection Type</th> 
                                        <th>Location Type</th>
                                        <th>Continet</th>
                                        <th>Zone</th>
                                        <th>Connector Size</th>                    
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {props?.info.listCloudConnInter.map((d:any,i:any)=>(
                                          <tr key={i}>
                                          <td>{d.ConexionInterReg}</td>
                                          <td>{d.LocacionInter}</td>
                                          <td>{d.ContinenteInterreg}</td>
                                          <td>{ d.ZonaInter}</td>
                                          <td>{d.CapacidadInterReg}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 2B*/}


                 {/* begin::Table 3 */}
               { props?.info.listCEdgeConn.length !== 0 &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Edge Peering Connectors</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                      <th>Network Provider</th>
                                      <th>Quantity</th>
                                      <th>Connector Size </th>                               
                                      <th>Total</th>
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {props?.info.listCEdgeConn.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.opcionEdge}</td>
                                            <td>{d.cantidadedge}</td>
                                            <td>{d.capacidadedge}</td>
                                            <td>{d.totaledge}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 3*/}

                {/* begin::Table 4 */}
                {props?.info.listVRF.length !==0 &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VRF's</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                         <th>Name</th>
                                         
                                      </tr>
                                  </thead>


                                  <tbody className='text-center'>
                                      {props?.info.listVRF.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.VRF_name}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>

                              </table>
                          </div>
                        

                      </div>
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 4*/}

                 {/* begin::Table 5 */}
                 {arrayDeObjetos.length !==0 &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VRF's</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='tablex'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                         <th>Name</th>
                                         <th>Outbund</th>
                                         
                                      </tr>
                                  </thead>


                                  <tbody className='text-center'>
                                      {arrayDeObjetos.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.nombre}</td>
                                            <td>{d.valor}</td>
                                          </tr>
                                      ))
                                      }

                                      {arrayDeObjetosIntra.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.nombre}</td>
                                            <td>{d.valor}</td>
                                          </tr>
                                      ))
                                      }
                                      {arrayDeObjetosInter.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.nombre}</td>
                                            <td>{d.valor}</td>
                                          </tr>
                                      ))
                                      }
                                      {arrayDeObjetosEdge.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.nombre}</td>
                                            <td>{d.valor}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>

                              </table>
                          </div>
                        

                      </div>
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 5*/}

                

              { props?.info.Security.length !== 0 &&
              <div className='bg-light-info p-8 rounded text-center'>
                  <h4 className='text-gray-500 text-center'> Your security</h4>
                  <br />
                    <div >
                      {props?.info.Security.map((securidad:any,i:any)=>
                        <p key={i}> <strong className='text-info'> {securidad}</strong></p>
                      )}

                    </div>
                </div>}

                <br />

                {/* begin::Action */}
               <div className="d-flex flex-row flex-column-fluid">
                  <div className="d-flex flex-row-fluid  flex-center">
                      <button
                      type='submit'
                      id='kt_sign_in_submit'
                      className='btn btn-danger'
                      onClick={() => props?.setID(undefined)}
                    > Cancel</button>
                  </div>

                  <div className="d-flex flex-row-fluid  flex-center">
                    <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-success'
                    onClick={handleSubmit}
                  > Send</button>
                  </div>
              </div>
                

              </div>
               
               <div className='d-grid mb-10'>
                                  
               
              </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


     
      
    </>
  )
}
export {Resumensolicitud}